<template>
  <b-modal id="drilldownReport" size="xl" :title="reportTitle">
    <div id="drilldown" class="row col-12 m-auto p-0">
      <b-table
        id="table-drilldown"
        :items="items"
        :fields="fields"
        :per-page="10"
        :current-page="currentPage"
        caption-bottom
        sort-icon-left
      >
        <template v-slot:cell(controlId)="row">
          <a :href="`/treatments/${row.item.answerId}`" target="_blank">
            {{ row.item.controlId }}
          </a>
        </template>
        <template v-slot:cell(data_resposta)="row">
          {{ dateFormat(new Date(row.item.data_resposta)) }}
        </template>
        <template v-slot:cell(feedback)="row">
          <span :title="row.item.feedback">
            {{ formatFeedback(row.item.feedback) }}
          </span>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="mt-4 mb-4">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalAnswers"
            :per-page="10"
            aria-controls="table-drilldown"
          ></b-pagination>
        </div>
      </div>
      <div
        class="col-6 mt-2 text-right"
        v-if="userProfile.permissions.files.download"
      >
        <a @click="exportToXLS" title="Exportar para XLS">
          <span class="xls">
            <i class="fas fa-file-download"></i>
          </span>
        </a>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import XLSX from 'xlsx';
// import swal from 'sweetalert';

export default {
  props: {
    questions: {
      type: Array,
    },
    answers: {
      type: Array,
    },
    title: {
      type: String,
    },
  },

  name: 'drilldownReport',

  data() {
    return {
      items: [],
      fields: [],
      currentPage: 1,
      totalAnswers: 0,
      reportTitle: '',
      isFCSI: false,
    };
  },

  computed: {
    ...mapState('actions', ['allActions']),
    ...mapState('branches', ['ih1']),
    ...mapState('authentication', ['userProfile']),
  },

  methods: {
    adjustAnswers() {
      for (let i = 0; i < this.answers.length; i += 1) {
        // anonymous
        if (this.userProfile.permissions.answers.anonymous_profile) {
          this.answers[i].nome = '*****';
          this.answers[i].telefone = '*****';
          this.answers[i].email = '*****';
        }
        // get IH1 name
        if (this.answers[i].filial) {
          for (let j = 0; j < this.ih1.listFilters.length; j += 1) {
            if (this.answers[i].filial === this.ih1.listFilters[j]._id) {
              this.answers[i].filial = this.ih1.listFilters[j].corporate_name;
              break;
            }
          }
        }
        // get action name
        for (let j = 0; j < this.allActions.length; j += 1) {
          if (this.answers[i].acao === this.allActions[j]._id) {
            this.answers[i].actionId = this.answers[i].acao;
            this.answers[i].acao = this.allActions[j].controlId;
            break;
          }
        }
        // get questions and reviews
        let total = 0;
        let qtdReview = 0;
        for (
          let j = 0;
          j < this.answers[i].additionalQuestions.length;
          j += 1
        ) {
          this.answers[i][
            this.answers[i].additionalQuestions[j].question
          ] = this.answers[i].additionalQuestions[j].review;
          if (this.answers[i].additionalQuestions[j].review >= 0) {
            qtdReview += 1;
            total += this.answers[i].additionalQuestions[j].review;
          }
        }
        if (qtdReview) {
          if (this.isFCSI) {
            this.answers[i].indice = (total / qtdReview).toFixed(2);
          } else {
            this.answers[i].indice = (100 * (total / qtdReview)).toFixed(0);
          }
        } else {
          this.answers[i].indice = 0;
        }
      }
    },
    dateFormat(param) {
      const date = format(new Date(param), 'dd/MM/yyyy', { locale: pt });
      return date;
    },
    formatFeedback(param) {
      let newFeed = null;
      if (param) {
        if (param.length > 20) {
          newFeed = `${param.substring(0, 20)}...`;
        } else {
          newFeed = param;
        }
      }
      return newFeed;
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    exportToXLS() {
      const header = [];
      for (let i = 0; i < this.fields.length; i += 1) {
        header.push(this.fields[i].key);
      }
      const arr = JSON.parse(JSON.stringify(this.items));
      for (let i = 0; i < arr.length; i += 1) {
        delete arr[i].additionalQuestions;
        delete arr[i].tipo;
        delete arr[i].metrica;
        arr[i].data_resposta = this.dateFormat(arr[i].data_resposta);
      }
      const wb = XLSX.utils.book_new();
      wb.SheetNames.push(this.title);

      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets[this.title] = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', `${this.title}.xlsx`);
      document.body.appendChild(link);
      link.click();
    },
  },

  async mounted() {
    const idx = this.title.indexOf('FCSI');
    this.isFCSI = idx >= 0;
    await this.adjustAnswers();
    this.reportTitle = `Detalhamento do índice ${this.title}`;
    this.items = this.answers;
    this.totalAnswers = this.answers.length;
    this.fields = [
      {
        key: 'controlId',
        label: 'ID',
        sortable: true,
      },
      {
        key: 'nome',
        label: 'nome',
        sortable: true,
      },
      {
        key: 'email',
        label: 'email',
        sortable: true,
      },
      {
        key: 'telefone',
        label: 'telefone',
        sortable: true,
      },
      {
        key: 'canal',
        label: 'canal',
        sortable: true,
      },
      {
        key: 'acao',
        label: 'acao',
        sortable: true,
      },
      {
        key: 'nota',
        label: 'nota',
        sortable: true,
      },
      {
        key: 'feedback',
        label: 'feedback',
        sortable: true,
      },
      {
        key: 'data_resposta',
        label: 'data resposta',
        sortable: true,
      },
      {
        key: 'filial',
        label: 'filial',
        sortable: true,
      },
    ];
    for (let i = 0; i < this.questions.length; i += 1) {
      this.fields.push({
        key: this.questions[i].question,
        label: this.questions[i].question,
        class: 'text-center',
      });
    }
    this.fields.push({
      key: 'indice',
      label: 'indice',
      class: 'text-center',
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

#drilldown {
  font-size: 10px;
  overflow: auto;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/modal-drilldown/index.vue